if (!customElements.get('product-bundles')) {
  customElements.define(
    'product-bundles',
    class ProductBundles extends HTMLElement {
      constructor() {
        super();
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.addToCartButton = document.querySelector('[data-add-bundle-to-cart]');
        this.variants = document.querySelectorAll('[data-variant-id]');
      }

      get variantId() {
        return this.dataset.id;
      }

      get price() {
        return Number(this.dataset.price) / 100;
      }

      get size() {
        return Number(this.dataset.size);
      }

      get currency() {
        return this.dataset.currency;
      }

      connectedCallback() {
        if (!this.addToCartButton || this.variants.length === 0) return;
        this.addToCartButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.handleAddToCart();
        });

        this.variants.forEach((variant) =>
          variant.addEventListener('change', () => {
            this.handleOptionChange(variant);
          }),
        );

        document.addEventListener('cart::ready-for-updated', () => this.checkItemsAvailability());
      }

      handleOptionChange(input) {
        const placeholder = input.name.toLowerCase();
        const selectedOption = document.querySelector(`[data-${placeholder}]`);
        const selectedPrice = document.querySelector(`[data-${placeholder}-price]`);
        if (!selectedOption) return;
        selectedOption.innerText = input.value;
        if (!selectedPrice) return;
        selectedPrice.innerText = input.dataset.itemPrice;
        this.calculateTotalPrice();
        this.buildUrlForVariant();
        this.addToCartButtonState();
      }

      async handleAddToCart() {
        const selectedVariants = document.querySelectorAll('[data-variant-id]:checked');
        if (selectedVariants.length === 0) return;
        const url = `${window.Shopify.routes.root}cart/add.js`;
        this.addToCartButton.disabled = true;
        this.addToCartButton.setAttribute('aria-disabled', true);
        this.addToCartButton.classList.add('loading');
        this.addToCartButton.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = {
          items: [
            {
              id: this.variantId,
              quantity: 1,
              properties: this.lineItemProperties(selectedVariants),
            },
          ],
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        };
        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        };

        const response = await fetch(url, config);
        const result = await response.json();

        if (result.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: this.variantId,
            errors: result.errors || result.description,
            message: result.message,
          });
          this.handleErrorMessage(result.description);
        } else {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: this.variantId,
            cartData: result,
          });
          this.addToCartButton.disabled = false;
          this.addToCartButton.removeAttribute('aria-disabled');
          this.addToCartButton.classList.remove('loading');
          this.addToCartButton.querySelector('.loading__spinner').classList.add('hidden');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.checkItemsAvailability();
        }
      }

      lineItemProperties(selectedVariants) {
        let properties = {};
        selectedVariants.forEach((variant, index) => {
          const productTitle = variant.dataset.productTitle;
          const variantTitle = variant.dataset.variantTitle;
          properties[`${index + 1}: ${productTitle}`] = variantTitle;
        });
        properties._bundleOperation = this.prepareBundleOperation(selectedVariants);
        return properties;
      }

      prepareBundleOperation(selectedVariants) {
        let operations = [];
        const pricePerUnit = Number((this.price / this.size).toFixed(2));
        const priceDifference = this.price - pricePerUnit * this.size;
        selectedVariants.forEach((item, index) => {
          const id = item.dataset.variantId;
          operations.push({
            id: id,
            quantity: 1,
            price: index !== this.size - 1 ? pricePerUnit : pricePerUnit + priceDifference,
          });
        });

        return operations;
      }

      handleErrorMessage(errorMessage = false) {
        const errorMessageWrapper = document.querySelector('.product-form__error-message-wrapper');
        if (!errorMessageWrapper) return;
        const errorMessageEl = errorMessageWrapper.querySelector('.product-form__error-message');

        errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessageEl) {
          errorMessageEl.textContent = errorMessage;
        }
        setTimeout(() => {
          this.addToCartButton.disabled = false;
          this.addToCartButton.removeAttribute('aria-disabled');
          this.addToCartButton.classList.remove('loading');
          this.addToCartButton.querySelector('.loading__spinner').classList.add('hidden');
        }, 300);
      }

      calculateTotalPrice() {
        let total = 0;
        this.variants.forEach((variant) => {
          if (variant.checked) {
            const priceFormatted = Number(variant.dataset.itemPrice.replace(this.currency, ''));
            total += priceFormatted;
          }
        });

        const totalContainer = document.querySelector('[data-bundle-compare-price]');
        if (!totalContainer) return;
        totalContainer.innerHTML = `${this.currency}${total.toLocaleString('en-US', { minimumFractionDigits: 2 })}`;

        const badge = document.querySelector('[data-bundle-save-badge]');
        if (badge && total > 0 && this.price > 0 && total > this.price) {
          const savingsPercent = Math.round(((total - this.price) / total) * 100);
          badge.innerHTML = `<strong>Bundle & Save ${savingsPercent}%</strong>`;
          badge.style.display = '';
        } else if (badge) {
          badge.style.display = 'none';
        }
      }

      buildUrlForVariant() {
        let ids = [];
        const selectedVariants = document.querySelectorAll('[data-variant-id]:checked');
        if (selectedVariants.length <= 1) return;
        selectedVariants.forEach((variant) => {
          ids.push(variant.dataset.variantId);
        });

        const url = `${location.origin}${location.pathname}?selected_variants=${ids.join(',')}`;
        history.replaceState({}, '', url);
      }

      addToCartButtonState() {
        let addToCartShouldBeDisabled = false;
        const conditions = document.querySelectorAll('[data-conditions]');
        if (conditions.length === 0) return;
        conditions.forEach((condition) => {
          const variants = condition.querySelectorAll('[data-variant-id]');
          if (variants.length > 0) {
            variants.forEach((variant) => {
              const variantQuantity = Number(variant.dataset.itemOriginalQuantity);
              if (variantQuantity === 0) variant.disabled = true;
            });
          }
          const notDisabledVariants = condition.querySelectorAll('[data-variant-id]:not(:disabled)');
          if (notDisabledVariants.length === 0) addToCartShouldBeDisabled = true;
          const currentVariantDisabled = condition.querySelector('[data-variant-id]:checked:disabled');
          if (currentVariantDisabled) addToCartShouldBeDisabled = true;
        });

        this.addToCartButton.disabled = addToCartShouldBeDisabled;
      }

      async checkItemsAvailability() {
        const url = window.location.href;
        const response = await fetch(url);
        const result = await response.text();
        const parser = new DOMParser().parseFromString(result, 'text/html');
        const widgetContainer = document.querySelector('#product-bundles-container');
        const newWidget = parser.querySelector('#product-bundles-container');
        if (widgetContainer && newWidget) {
          widgetContainer.innerHTML = newWidget.innerHTML;
        }
        this.addToCartButtonState();
      }
    },
  );
}
